import React from 'react';
import { OpenHours } from 'types/FarmData';
import { WorkingTimeWrapper } from './style';

interface DayTimeProps {
  dayTime: OpenHours | undefined;
};

const DayTime: React.FC<DayTimeProps> = ({ dayTime }) => (
  <span className="day-time">
    {(dayTime && dayTime.no && dayTime.lidz) ? `${dayTime.no} - ${dayTime.lidz}` : '-'}
  </span>
);

interface WorkingTimeProps {
  daysOfWeek: string[];
  workingTime: OpenHours[];
  workingTimeTitle?: string;
}

const WorkingTime: React.FC<WorkingTimeProps> = ({ daysOfWeek, workingTime, workingTimeTitle }) => (
  <WorkingTimeWrapper>
    {workingTimeTitle && (
      <p className="working-time-title">{workingTimeTitle}</p>
    )}
    
    <div className="working-time">
      {daysOfWeek.map((day, index) => (
        <div key={index} className="day-time-row">
          <span className="day-name">{day}</span>
          <DayTime dayTime={workingTime[index + 1]} />
        </div>
      ))}
    </div>
  </WorkingTimeWrapper>
);

export default WorkingTime;
